/* ============ BKS VELTO — configurateur (même moteur que le scooter) ============
   L'interface est pilotée par finitions.json, généré depuis les calques réels par
   build-finitions-velto.js : une combinaison sans calque n'est jamais proposée.

   Différences avec le scooter :
     · zones      dessus, côté bas, côté haut, insert, 3 bandes, logo
     · bandes     toujours présentes — pas de mode « aucune »
     · broderies  le numéro va sur le DESSUS ARRIÈRE, l'avant portant le logo BKS
   ============================================================================ */
(function(){
'use strict';

/* Où chercher les calques. En local : _couleurs/<zone>/<slug>.webp.
   Sur la boutique tout est à plat sur le CDN : vl-<zone>-<slug>.webp.
   Le script de déploiement remplace ces quatre lignes — ne pas les reformater.
   VER : le CDN met les images en cache un an, ce suffixe force le rafraîchissement
   quand un calque change, et lui seul. */
var IMG = 'https://cdn.shopify.com/s/files/1/0400/3086/3513/files/vl-';
var SEP = '-';
var UI  = 'https://cdn.shopify.com/s/files/1/0400/3086/3513/files/vl-';
var VER = '?v=1788801128';
function urlCalque(zone, slug){ return IMG + zone + SEP + slug + '.webp' + VER; }

var FIN = null;                               /* catalogue des finitions */

/* Les finitions sont INCRUSTÉES ici : ouvert par double-clic (file://), Chrome
   bloque fetch() et la page resterait vide. build-finitions-velto.js les réécrit. */
/* @@FINITIONS_DEBUT@@ */
var FIN_INTEGRE = {"base":[{"slug":"base","nom":"Base","matiere":"Simili","couleur":null,"hex":"#777777","prix":0}],"cote-bas":[{"slug":"noir","nom":"Noir","matiere":"Simili","couleur":"noir","hex":"#353535","prix":0},{"slug":"blanc","nom":"Blanc","matiere":"Simili","couleur":"blanc","hex":"#c6c6c6","prix":0},{"slug":"gris","nom":"Gris","matiere":"Simili","couleur":"gris","hex":"#686868","prix":0},{"slug":"rouge","nom":"Rouge","matiere":"Simili","couleur":"rouge","hex":"#ba1636","prix":0},{"slug":"orange","nom":"Orange","matiere":"Simili","couleur":"orange","hex":"#ba5617","prix":0},{"slug":"jaune","nom":"Jaune","matiere":"Simili","couleur":"jaune","hex":"#bba518","prix":0},{"slug":"vert","nom":"Vert","matiere":"Simili","couleur":"vert","hex":"#7aba17","prix":0},{"slug":"turquoise","nom":"Turquoise","matiere":"Simili","couleur":"turquoise","hex":"#19b9b7","prix":0},{"slug":"bleu-clair","nom":"Bleu clair","matiere":"Simili","couleur":"bleu-clair","hex":"#1786b7","prix":0},{"slug":"bleu","nom":"Bleu","matiere":"Simili","couleur":"bleu","hex":"#163cb6","prix":0},{"slug":"rose","nom":"Rose","matiere":"Simili","couleur":"rose","hex":"#b718b4","prix":0},{"slug":"violet","nom":"Violet","matiere":"Simili","couleur":"violet","hex":"#5f17b7","prix":0}],"cote-haut":[{"slug":"noir","nom":"Noir","matiere":"Simili","couleur":"noir","hex":"#3b3b3b","prix":0},{"slug":"blanc","nom":"Blanc","matiere":"Simili","couleur":"blanc","hex":"#d7d7d7","prix":0},{"slug":"gris","nom":"Gris","matiere":"Simili","couleur":"gris","hex":"#6d6d6d","prix":0},{"slug":"rouge","nom":"Rouge","matiere":"Simili","couleur":"rouge","hex":"#c01a25","prix":0},{"slug":"orange","nom":"Orange","matiere":"Simili","couleur":"orange","hex":"#cd6d0e","prix":0},{"slug":"jaune","nom":"Jaune","matiere":"Simili","couleur":"jaune","hex":"#cfb20d","prix":0},{"slug":"vert","nom":"Vert","matiere":"Simili","couleur":"vert","hex":"#82c11b","prix":0},{"slug":"turquoise","nom":"Turquoise","matiere":"Simili","couleur":"turquoise","hex":"#1bb7c0","prix":0},{"slug":"bleu-clair","nom":"Bleu clair","matiere":"Simili","couleur":"bleu-clair","hex":"#2e92ad","prix":0},{"slug":"bleu","nom":"Bleu","matiere":"Simili","couleur":"bleu","hex":"#2d41ad","prix":0},{"slug":"rose","nom":"Rose","matiere":"Simili","couleur":"rose","hex":"#c01ba1","prix":0},{"slug":"violet","nom":"Violet","matiere":"Simili","couleur":"violet","hex":"#871bc0","prix":0}],"dessus":[{"slug":"noir","nom":"Noir","matiere":"Simili","couleur":"noir","hex":"#333333","prix":0},{"slug":"blanc","nom":"Blanc","matiere":"Simili","couleur":"blanc","hex":"#efefef","prix":0},{"slug":"gris","nom":"Gris","matiere":"Simili","couleur":"gris","hex":"#767676","prix":0},{"slug":"rouge","nom":"Rouge","matiere":"Simili","couleur":"rouge","hex":"#d31918","prix":0},{"slug":"orange","nom":"Orange","matiere":"Simili","couleur":"orange","hex":"#ec9110","prix":0},{"slug":"jaune","nom":"Jaune","matiere":"Simili","couleur":"jaune","hex":"#dad123","prix":0},{"slug":"vert","nom":"Vert","matiere":"Simili","couleur":"vert","hex":"#87d418","prix":0},{"slug":"turquoise","nom":"Turquoise","matiere":"Simili","couleur":"turquoise","hex":"#18d2d3","prix":0},{"slug":"bleu-clair","nom":"Bleu clair","matiere":"Simili","couleur":"bleu-clair","hex":"#57a9cb","prix":0},{"slug":"bleu","nom":"Bleu","matiere":"Simili","couleur":"bleu","hex":"#383fc5","prix":0},{"slug":"rose","nom":"Rose","matiere":"Simili","couleur":"rose","hex":"#dc21bf","prix":0},{"slug":"violet","nom":"Violet","matiere":"Simili","couleur":"violet","hex":"#9918d3","prix":0},{"slug":"alcantara-noir","nom":"Alcantara noir","matiere":"Alcantara","couleur":"noir","hex":"#2c2d2c","prix":50},{"slug":"alcantara-rouge","nom":"Alcantara rouge","matiere":"Alcantara","couleur":"rouge","hex":"#d41918","prix":50},{"slug":"alcantara-orange","nom":"Alcantara orange","matiere":"Alcantara","couleur":"orange","hex":"#d47514","prix":50},{"slug":"alcantara-turquoise","nom":"Alcantara turquoise","matiere":"Alcantara","couleur":"turquoise","hex":"#14cecf","prix":50},{"slug":"alcantara-bleu","nom":"Alcantara bleu","matiere":"Alcantara","couleur":"bleu","hex":"#3114d4","prix":50},{"slug":"alcantara-violet","nom":"Alcantara violet","matiere":"Alcantara","couleur":"violet","hex":"#8a14d4","prix":50}],"grip":[{"slug":"noir","nom":"Noir","matiere":"Simili","couleur":"noir","hex":"#3a3a3a","prix":0},{"slug":"blanc","nom":"Blanc","matiere":"Simili","couleur":"blanc","hex":"#d0d0d0","prix":0},{"slug":"gris","nom":"Gris","matiere":"Simili","couleur":"gris","hex":"#6f6f6f","prix":0},{"slug":"rouge","nom":"Rouge","matiere":"Simili","couleur":"rouge","hex":"#d70939","prix":0},{"slug":"orange","nom":"Orange","matiere":"Simili","couleur":"orange","hex":"#d6720b","prix":0},{"slug":"jaune","nom":"Jaune","matiere":"Simili","couleur":"jaune","hex":"#bebc20","prix":0},{"slug":"vert","nom":"Vert","matiere":"Simili","couleur":"vert","hex":"#a3d70b","prix":0},{"slug":"turquoise","nom":"Turquoise","matiere":"Simili","couleur":"turquoise","hex":"#0bd7be","prix":0},{"slug":"bleu-clair","nom":"Bleu clair","matiere":"Simili","couleur":"bleu-clair","hex":"#1fa5be","prix":0},{"slug":"bleu","nom":"Bleu","matiere":"Simili","couleur":"bleu","hex":"#1f50be","prix":0},{"slug":"rose","nom":"Rose","matiere":"Simili","couleur":"rose","hex":"#d609aa","prix":0},{"slug":"violet","nom":"Violet","matiere":"Simili","couleur":"violet","hex":"#7609d6","prix":0},{"slug":"alcantara-noir","nom":"Alcantara noir","matiere":"Alcantara","couleur":"noir","hex":"#454545","prix":20},{"slug":"alcantara-rouge","nom":"Alcantara rouge","matiere":"Alcantara","couleur":"rouge","hex":"#c12e28","prix":20},{"slug":"alcantara-orange","nom":"Alcantara orange","matiere":"Alcantara","couleur":"orange","hex":"#c16623","prix":20},{"slug":"alcantara-jaune","nom":"Alcantara jaune","matiere":"Alcantara","couleur":"jaune","hex":"#c0a423","prix":20},{"slug":"alcantara-turquoise","nom":"Alcantara turquoise","matiere":"Alcantara","couleur":"turquoise","hex":"#22a7c0","prix":20},{"slug":"alcantara-bleu","nom":"Alcantara bleu","matiere":"Alcantara","couleur":"bleu","hex":"#2a2ac1","prix":20},{"slug":"alcantara-violet","nom":"Alcantara violet","matiere":"Alcantara","couleur":"violet","hex":"#7022c1","prix":20},{"slug":"carbone-noir","nom":"Carbone noir","matiere":"Carbone","couleur":"noir","hex":"#353438","prix":10},{"slug":"carbone-blanc","nom":"Carbone blanc","matiere":"Carbone","couleur":"blanc","hex":"#c8c9c5","prix":10},{"slug":"carbone-forge-noir","nom":"Carbone forgé noir","matiere":"Carbone forgé","couleur":"noir","hex":"#3b3b3b","prix":10},{"slug":"carbone-forge-rouge","nom":"Carbone forgé rouge","matiere":"Carbone forgé","couleur":"rouge","hex":"#9a1f2e","prix":10},{"slug":"carbone-forge-bleu","nom":"Carbone forgé bleu","matiere":"Carbone forgé","couleur":"bleu","hex":"#1f2d9a","prix":10},{"slug":"carbone-forge-violet","nom":"Carbone forgé violet","matiere":"Carbone forgé","couleur":"violet","hex":"#561f9a","prix":10},{"slug":"chrome-rouge","nom":"Chrome rouge","matiere":"Chrome","couleur":"rouge","hex":"#c42f35","prix":25},{"slug":"chrome-orange","nom":"Chrome orange","matiere":"Chrome","couleur":"orange","hex":"#c46a2d","prix":25},{"slug":"chrome-vert","nom":"Chrome vert","matiere":"Chrome","couleur":"vert","hex":"#70c52e","prix":25},{"slug":"chrome-turquoise","nom":"Chrome turquoise","matiere":"Chrome","couleur":"turquoise","hex":"#2ec5b7","prix":25},{"slug":"chrome-bleu","nom":"Chrome bleu","matiere":"Chrome","couleur":"bleu","hex":"#2e58c3","prix":25},{"slug":"chrome-rose","nom":"Chrome rose","matiere":"Chrome","couleur":"rose","hex":"#c42ebe","prix":25},{"slug":"chrome-violet","nom":"Chrome violet","matiere":"Chrome","couleur":"violet","hex":"#852ec3","prix":25},{"slug":"chrome-or","nom":"Chrome or","matiere":"Chrome","couleur":"or","hex":"#c59a2d","prix":25},{"slug":"holo","nom":"Holographique","matiere":"Holographique","couleur":null,"hex":"#94a2a2","prix":25}],"grip1":[{"slug":"noir","nom":"Noir","matiere":"Simili","couleur":"noir","hex":"#3f3f3f","prix":0},{"slug":"blanc","nom":"Blanc","matiere":"Simili","couleur":"blanc","hex":"#d7d7d7","prix":0},{"slug":"gris","nom":"Gris","matiere":"Simili","couleur":"gris","hex":"#757575","prix":0},{"slug":"rouge","nom":"Rouge","matiere":"Simili","couleur":"rouge","hex":"#df0b3d","prix":0},{"slug":"orange","nom":"Orange","matiere":"Simili","couleur":"orange","hex":"#e0780d","prix":0},{"slug":"jaune","nom":"Jaune","matiere":"Simili","couleur":"jaune","hex":"#c5c325","prix":0},{"slug":"vert","nom":"Vert","matiere":"Simili","couleur":"vert","hex":"#ace00e","prix":0},{"slug":"turquoise","nom":"Turquoise","matiere":"Simili","couleur":"turquoise","hex":"#0ee0c6","prix":0},{"slug":"bleu-clair","nom":"Bleu clair","matiere":"Simili","couleur":"bleu-clair","hex":"#24acc5","prix":0},{"slug":"bleu","nom":"Bleu","matiere":"Simili","couleur":"bleu","hex":"#2455c5","prix":0},{"slug":"rose","nom":"Rose","matiere":"Simili","couleur":"rose","hex":"#df0cb2","prix":0},{"slug":"violet","nom":"Violet","matiere":"Simili","couleur":"violet","hex":"#7b0bdf","prix":0},{"slug":"alcantara-noir","nom":"Alcantara noir","matiere":"Alcantara","couleur":"noir","hex":"#494949","prix":20},{"slug":"alcantara-rouge","nom":"Alcantara rouge","matiere":"Alcantara","couleur":"rouge","hex":"#c9302b","prix":20},{"slug":"alcantara-orange","nom":"Alcantara orange","matiere":"Alcantara","couleur":"orange","hex":"#c96a25","prix":20},{"slug":"alcantara-jaune","nom":"Alcantara jaune","matiere":"Alcantara","couleur":"jaune","hex":"#c9ab26","prix":20},{"slug":"alcantara-turquoise","nom":"Alcantara turquoise","matiere":"Alcantara","couleur":"turquoise","hex":"#25b0c8","prix":20},{"slug":"alcantara-bleu","nom":"Alcantara bleu","matiere":"Alcantara","couleur":"bleu","hex":"#2d2dc9","prix":20},{"slug":"alcantara-violet","nom":"Alcantara violet","matiere":"Alcantara","couleur":"violet","hex":"#7425c9","prix":20},{"slug":"carbone-noir","nom":"Carbone noir","matiere":"Carbone","couleur":"noir","hex":"#37363a","prix":10},{"slug":"carbone-blanc","nom":"Carbone blanc","matiere":"Carbone","couleur":"blanc","hex":"#c6c7c2","prix":10},{"slug":"carbone-forge-noir","nom":"Carbone forgé noir","matiere":"Carbone forgé","couleur":"noir","hex":"#3a3a3a","prix":10},{"slug":"carbone-forge-rouge","nom":"Carbone forgé rouge","matiere":"Carbone forgé","couleur":"rouge","hex":"#95202e","prix":10},{"slug":"carbone-forge-bleu","nom":"Carbone forgé bleu","matiere":"Carbone forgé","couleur":"bleu","hex":"#1f2e94","prix":10},{"slug":"carbone-forge-violet","nom":"Carbone forgé violet","matiere":"Carbone forgé","couleur":"violet","hex":"#542095","prix":10},{"slug":"chrome-rouge","nom":"Chrome rouge","matiere":"Chrome","couleur":"rouge","hex":"#c4373c","prix":25},{"slug":"chrome-orange","nom":"Chrome orange","matiere":"Chrome","couleur":"orange","hex":"#c57035","prix":25},{"slug":"chrome-vert","nom":"Chrome vert","matiere":"Chrome","couleur":"vert","hex":"#76c735","prix":25},{"slug":"chrome-turquoise","nom":"Chrome turquoise","matiere":"Chrome","couleur":"turquoise","hex":"#35c7b9","prix":25},{"slug":"chrome-bleu","nom":"Chrome bleu","matiere":"Chrome","couleur":"bleu","hex":"#355fc3","prix":25},{"slug":"chrome-rose","nom":"Chrome rose","matiere":"Chrome","couleur":"rose","hex":"#c536c0","prix":25},{"slug":"chrome-violet","nom":"Chrome violet","matiere":"Chrome","couleur":"violet","hex":"#8b36c4","prix":25},{"slug":"chrome-or","nom":"Chrome or","matiere":"Chrome","couleur":"or","hex":"#c79e35","prix":25},{"slug":"holo","nom":"Holographique","matiere":"Holographique","couleur":null,"hex":"#98a8a6","prix":25}],"grip2":[{"slug":"noir","nom":"Noir","matiere":"Simili","couleur":"noir","hex":"#3d3d3d","prix":0},{"slug":"blanc","nom":"Blanc","matiere":"Simili","couleur":"blanc","hex":"#d5d5d5","prix":0},{"slug":"gris","nom":"Gris","matiere":"Simili","couleur":"gris","hex":"#737373","prix":0},{"slug":"rouge","nom":"Rouge","matiere":"Simili","couleur":"rouge","hex":"#dc0c3b","prix":0},{"slug":"orange","nom":"Orange","matiere":"Simili","couleur":"orange","hex":"#dc770e","prix":0},{"slug":"jaune","nom":"Jaune","matiere":"Simili","couleur":"jaune","hex":"#c3c125","prix":0},{"slug":"vert","nom":"Vert","matiere":"Simili","couleur":"vert","hex":"#a8dd0f","prix":0},{"slug":"turquoise","nom":"Turquoise","matiere":"Simili","couleur":"turquoise","hex":"#0eddc3","prix":0},{"slug":"bleu-clair","nom":"Bleu clair","matiere":"Simili","couleur":"bleu-clair","hex":"#24a9c2","prix":0},{"slug":"bleu","nom":"Bleu","matiere":"Simili","couleur":"bleu","hex":"#2354c1","prix":0},{"slug":"rose","nom":"Rose","matiere":"Simili","couleur":"rose","hex":"#dc0cae","prix":0},{"slug":"violet","nom":"Violet","matiere":"Simili","couleur":"violet","hex":"#7b0cdc","prix":0},{"slug":"alcantara-noir","nom":"Alcantara noir","matiere":"Alcantara","couleur":"noir","hex":"#474747","prix":20},{"slug":"alcantara-rouge","nom":"Alcantara rouge","matiere":"Alcantara","couleur":"rouge","hex":"#c6302a","prix":20},{"slug":"alcantara-orange","nom":"Alcantara orange","matiere":"Alcantara","couleur":"orange","hex":"#c66925","prix":20},{"slug":"alcantara-jaune","nom":"Alcantara jaune","matiere":"Alcantara","couleur":"jaune","hex":"#c6a825","prix":20},{"slug":"alcantara-turquoise","nom":"Alcantara turquoise","matiere":"Alcantara","couleur":"turquoise","hex":"#25acc5","prix":20},{"slug":"alcantara-bleu","nom":"Alcantara bleu","matiere":"Alcantara","couleur":"bleu","hex":"#2c2dc6","prix":20},{"slug":"alcantara-violet","nom":"Alcantara violet","matiere":"Alcantara","couleur":"violet","hex":"#7324c6","prix":20},{"slug":"carbone-noir","nom":"Carbone noir","matiere":"Carbone","couleur":"noir","hex":"#363538","prix":10},{"slug":"carbone-blanc","nom":"Carbone blanc","matiere":"Carbone","couleur":"blanc","hex":"#c7c8c4","prix":10},{"slug":"carbone-forge-noir","nom":"Carbone forgé noir","matiere":"Carbone forgé","couleur":"noir","hex":"#3c3c3c","prix":10},{"slug":"carbone-forge-rouge","nom":"Carbone forgé rouge","matiere":"Carbone forgé","couleur":"rouge","hex":"#9a202e","prix":10},{"slug":"carbone-forge-bleu","nom":"Carbone forgé bleu","matiere":"Carbone forgé","couleur":"bleu","hex":"#1f2d99","prix":10},{"slug":"carbone-forge-violet","nom":"Carbone forgé violet","matiere":"Carbone forgé","couleur":"violet","hex":"#57209a","prix":10},{"slug":"chrome-rouge","nom":"Chrome rouge","matiere":"Chrome","couleur":"rouge","hex":"#c12d33","prix":25},{"slug":"chrome-orange","nom":"Chrome orange","matiere":"Chrome","couleur":"orange","hex":"#c1682b","prix":25},{"slug":"chrome-vert","nom":"Chrome vert","matiere":"Chrome","couleur":"vert","hex":"#6fc32c","prix":25},{"slug":"chrome-turquoise","nom":"Chrome turquoise","matiere":"Chrome","couleur":"turquoise","hex":"#2cc3b4","prix":25},{"slug":"chrome-bleu","nom":"Chrome bleu","matiere":"Chrome","couleur":"bleu","hex":"#2b57c0","prix":25},{"slug":"chrome-rose","nom":"Chrome rose","matiere":"Chrome","couleur":"rose","hex":"#c22cbc","prix":25},{"slug":"chrome-violet","nom":"Chrome violet","matiere":"Chrome","couleur":"violet","hex":"#832cc1","prix":25},{"slug":"chrome-or","nom":"Chrome or","matiere":"Chrome","couleur":"or","hex":"#c2972c","prix":25},{"slug":"holo","nom":"Holographique","matiere":"Holographique","couleur":null,"hex":"#95a3a3","prix":25}],"grip3":[{"slug":"noir","nom":"Noir","matiere":"Simili","couleur":"noir","hex":"#333333","prix":0},{"slug":"blanc","nom":"Blanc","matiere":"Simili","couleur":"blanc","hex":"#c4c4c4","prix":0},{"slug":"gris","nom":"Gris","matiere":"Simili","couleur":"gris","hex":"#666666","prix":0},{"slug":"rouge","nom":"Rouge","matiere":"Simili","couleur":"rouge","hex":"#c90634","prix":0},{"slug":"orange","nom":"Orange","matiere":"Simili","couleur":"orange","hex":"#c86908","prix":0},{"slug":"jaune","nom":"Jaune","matiere":"Simili","couleur":"jaune","hex":"#b4b219","prix":0},{"slug":"vert","nom":"Vert","matiere":"Simili","couleur":"vert","hex":"#99c90a","prix":0},{"slug":"turquoise","nom":"Turquoise","matiere":"Simili","couleur":"turquoise","hex":"#09cab1","prix":0},{"slug":"bleu-clair","nom":"Bleu clair","matiere":"Simili","couleur":"bleu-clair","hex":"#199cb3","prix":0},{"slug":"bleu","nom":"Bleu","matiere":"Simili","couleur":"bleu","hex":"#1848b3","prix":0},{"slug":"rose","nom":"Rose","matiere":"Simili","couleur":"rose","hex":"#c8069f","prix":0},{"slug":"violet","nom":"Violet","matiere":"Simili","couleur":"violet","hex":"#6d05c8","prix":0},{"slug":"alcantara-noir","nom":"Alcantara noir","matiere":"Alcantara","couleur":"noir","hex":"#414141","prix":20},{"slug":"alcantara-rouge","nom":"Alcantara rouge","matiere":"Alcantara","couleur":"rouge","hex":"#b62a23","prix":20},{"slug":"alcantara-orange","nom":"Alcantara orange","matiere":"Alcantara","couleur":"orange","hex":"#b6601f","prix":20},{"slug":"alcantara-jaune","nom":"Alcantara jaune","matiere":"Alcantara","couleur":"jaune","hex":"#b49b1f","prix":20},{"slug":"alcantara-turquoise","nom":"Alcantara turquoise","matiere":"Alcantara","couleur":"turquoise","hex":"#1e9cb4","prix":20},{"slug":"alcantara-bleu","nom":"Alcantara bleu","matiere":"Alcantara","couleur":"bleu","hex":"#2726b5","prix":20},{"slug":"alcantara-violet","nom":"Alcantara violet","matiere":"Alcantara","couleur":"violet","hex":"#691eb5","prix":20},{"slug":"carbone-noir","nom":"Carbone noir","matiere":"Carbone","couleur":"noir","hex":"#323235","prix":10},{"slug":"carbone-blanc","nom":"Carbone blanc","matiere":"Carbone","couleur":"blanc","hex":"#cbccc8","prix":10},{"slug":"carbone-forge-noir","nom":"Carbone forgé noir","matiere":"Carbone forgé","couleur":"noir","hex":"#3c3c3c","prix":10},{"slug":"carbone-forge-rouge","nom":"Carbone forgé rouge","matiere":"Carbone forgé","couleur":"rouge","hex":"#9c1f2e","prix":10},{"slug":"carbone-forge-bleu","nom":"Carbone forgé bleu","matiere":"Carbone forgé","couleur":"bleu","hex":"#1e2d9c","prix":10},{"slug":"carbone-forge-violet","nom":"Carbone forgé violet","matiere":"Carbone forgé","couleur":"violet","hex":"#571f9c","prix":10},{"slug":"chrome-rouge","nom":"Chrome rouge","matiere":"Chrome","couleur":"rouge","hex":"#c32a30","prix":25},{"slug":"chrome-orange","nom":"Chrome orange","matiere":"Chrome","couleur":"orange","hex":"#c36829","prix":25},{"slug":"chrome-vert","nom":"Chrome vert","matiere":"Chrome","couleur":"vert","hex":"#6ec529","prix":25},{"slug":"chrome-turquoise","nom":"Chrome turquoise","matiere":"Chrome","couleur":"turquoise","hex":"#29c5b6","prix":25},{"slug":"chrome-bleu","nom":"Chrome bleu","matiere":"Chrome","couleur":"bleu","hex":"#2955c2","prix":25},{"slug":"chrome-rose","nom":"Chrome rose","matiere":"Chrome","couleur":"rose","hex":"#c32abe","prix":25},{"slug":"chrome-violet","nom":"Chrome violet","matiere":"Chrome","couleur":"violet","hex":"#832ac2","prix":25},{"slug":"chrome-or","nom":"Chrome or","matiere":"Chrome","couleur":"or","hex":"#c49829","prix":25},{"slug":"holo","nom":"Holographique","matiere":"Holographique","couleur":null,"hex":"#919c9f","prix":25}],"insert":[{"slug":"noir","nom":"Noir","matiere":"Simili","couleur":"noir","hex":"#2d2d2d","prix":0},{"slug":"blanc","nom":"Blanc","matiere":"Simili","couleur":"blanc","hex":"#e1e1e1","prix":0},{"slug":"gris","nom":"Gris","matiere":"Simili","couleur":"gris","hex":"#777777","prix":0},{"slug":"rouge","nom":"Rouge","matiere":"Simili","couleur":"rouge","hex":"#dc1314","prix":0},{"slug":"orange","nom":"Orange","matiere":"Simili","couleur":"orange","hex":"#ef7e02","prix":0},{"slug":"jaune","nom":"Jaune","matiere":"Simili","couleur":"jaune","hex":"#c8c403","prix":0},{"slug":"vert","nom":"Vert","matiere":"Simili","couleur":"vert","hex":"#92dc13","prix":0},{"slug":"turquoise","nom":"Turquoise","matiere":"Simili","couleur":"turquoise","hex":"#12dcd4","prix":0},{"slug":"bleu-clair","nom":"Bleu clair","matiere":"Simili","couleur":"bleu-clair","hex":"#0b89ba","prix":0},{"slug":"bleu","nom":"Bleu","matiere":"Simili","couleur":"bleu","hex":"#0a3ab9","prix":0},{"slug":"rose","nom":"Rose","matiere":"Simili","couleur":"rose","hex":"#dc13c8","prix":0},{"slug":"violet","nom":"Violet","matiere":"Simili","couleur":"violet","hex":"#b613db","prix":0},{"slug":"carbone-noir","nom":"Carbone noir","matiere":"Carbone","couleur":"noir","hex":"#3a3838","prix":8},{"slug":"carbone-blanc","nom":"Carbone blanc","matiere":"Carbone","couleur":"blanc","hex":"#c6c8c7","prix":8},{"slug":"carbone-forge-noir","nom":"Carbone forgé noir","matiere":"Carbone forgé","couleur":"noir","hex":"#323232","prix":8},{"slug":"carbone-forge-rouge","nom":"Carbone forgé rouge","matiere":"Carbone forgé","couleur":"rouge","hex":"#60272a","prix":8},{"slug":"carbone-forge-bleu","nom":"Carbone forgé bleu","matiere":"Carbone forgé","couleur":"bleu","hex":"#273260","prix":8},{"slug":"carbone-forge-violet","nom":"Carbone forgé violet","matiere":"Carbone forgé","couleur":"violet","hex":"#412760","prix":8},{"slug":"chrome-argent","nom":"Chrome argent","matiere":"Chrome","couleur":"argent","hex":"#5b5b5b","prix":20},{"slug":"chrome-rouge","nom":"Chrome rouge","matiere":"Chrome","couleur":"rouge","hex":"#761018","prix":20},{"slug":"chrome-vert","nom":"Chrome vert","matiere":"Chrome","couleur":"vert","hex":"#11763a","prix":20},{"slug":"chrome-turquoise","nom":"Chrome turquoise","matiere":"Chrome","couleur":"turquoise","hex":"#116476","prix":20},{"slug":"chrome-bleu","nom":"Chrome bleu","matiere":"Chrome","couleur":"bleu","hex":"#131176","prix":20},{"slug":"chrome-rose","nom":"Chrome rose","matiere":"Chrome","couleur":"rose","hex":"#761056","prix":20},{"slug":"chrome-violet","nom":"Chrome violet","matiere":"Chrome","couleur":"violet","hex":"#5a1076","prix":20},{"slug":"chrome-or","nom":"Chrome or","matiere":"Chrome","couleur":"or","hex":"#766011","prix":20},{"slug":"holo","nom":"Holographique","matiere":"Holographique","couleur":null,"hex":"#a0adcc","prix":20}],"logo":[{"slug":"noir","nom":"Noir","matiere":"Simili","couleur":"noir","hex":"#262626","prix":0},{"slug":"blanc","nom":"Blanc","matiere":"Simili","couleur":"blanc","hex":"#d8d8d8","prix":0},{"slug":"gris","nom":"Gris","matiere":"Simili","couleur":"gris","hex":"#6d6d6d","prix":0},{"slug":"rouge","nom":"Rouge","matiere":"Simili","couleur":"rouge","hex":"#bd1f23","prix":0},{"slug":"orange","nom":"Orange","matiere":"Simili","couleur":"orange","hex":"#c06020","prix":0},{"slug":"jaune","nom":"Jaune","matiere":"Simili","couleur":"jaune","hex":"#c0aa21","prix":0},{"slug":"vert","nom":"Vert","matiere":"Simili","couleur":"vert","hex":"#9cbc1e","prix":0},{"slug":"turquoise","nom":"Turquoise","matiere":"Simili","couleur":"turquoise","hex":"#1fbf97","prix":0},{"slug":"bleu-clair","nom":"Bleu clair","matiere":"Simili","couleur":"bleu-clair","hex":"#1b91ba","prix":0},{"slug":"bleu","nom":"Bleu","matiere":"Simili","couleur":"bleu","hex":"#1a56ba","prix":0},{"slug":"rose","nom":"Rose","matiere":"Simili","couleur":"rose","hex":"#b91fb9","prix":0},{"slug":"violet","nom":"Violet","matiere":"Simili","couleur":"violet","hex":"#801ebe","prix":0},{"slug":"or","nom":"Or","matiere":"Simili","couleur":"or","hex":"#c09b20","prix":0}]};
/* @@FINITIONS_FIN@@ */

var SCDN = 'https://cdn.shopify.com/s/files/1/0400/3086/3513/files/';

/* ---------- fils de broderie et de couture ---------- */
/* Couleur de fil des BRODERIES — la palette de la FUSION, à l'identique : des
   aplats de couleur. Les vignettes de surpiqûre restent à l'étape Couture, où
   elles ont un sens ; sur une broderie elles donnaient treize carrés gris qu'on
   ne distinguait pas les uns des autres. */
var FILBROD = [
  ['Noir','#111111'],       ['Blanc','#f2f2f2'],     ['Gris','#8c8c8c'],
  ['Rouge','#e2231a'],      ['Orange','#e07b16'],    ['Jaune','#f7d000'],
  ['Doré','#d9a520'],       ['Vert','#3bbf2a'],      ['Turquoise','#1bb39a'],
  ['Bleu clair','#37a0e0'], ['Bleu','#1f4fd0'],      ['Violet','#7c3aed'],
  ['Rose','#e0249a']
];
function nomFilBrod(h){ for(var i=0;i<FILBROD.length;i++) if(FILBROD[i][1] === h) return FILBROD[i][0]; return h; }
function filBrodValide(h){ return nomFilBrod(h) === h ? FILBROD[1][1] : h; }   /* couleur inconnue -> blanc */

/* fil de COUTURE : là, la vignette de surpiqûre montre vraiment la matière */
var FILS = [
  ['Blanc','#f2f2f2','blanc'],       ['Noir','#111111','noir'],       ['Gris','#8c8c8c','gris'],
  ['Rouge','#e2231a','rouge'],       ['Orange','#e07b16','orange'],   ['Jaune','#f2d20a','jaune'],
  ['Jaune fluo','#d8f21a','jaune-fluo'], ['Doré','#c9a227','dore'],   ['Vert','#3bbf2a','vert'],
  ['Turquoise','#1bb39a','turquoise'],   ['Bleu','#1f4fd0','bleu'],
  ['Violet','#7c3aed','violet'],     ['Rose','#e0249a','rose']
];

/* ---------- les 18 motos de l'option « Moto 🏍️ » ---------- */
var MODELES = [
  'Derbi DRD Pro (2006-2014)',
  'Derbi Senda (2000-2010)',
  'Derbi Xtrem (2000-2010)',
  'Derbi XRace (2000-2010)',
  'Gilera SMT/RCR (2003-2010)',
  'Beta (2005-2010)',
  'Beta (Depuis 2021)',
  'Beta (2011-2020)',
  'Derbi Xrace (2011-2017)',
  'Derbi Senda (2011-2017)',
  'Derbi Xtrem (2011-2017)',
  'Derbi DRD Racing (2011-2017)',
  'Derbi DRD Racing (2005-2010)',
  'Gilera SMT (2011-2017)',
  'Sherco (Depuis 2013)',
  'MBK X-Limit (2003-2011)',
  'Yamaha DT (2003-2011)',
  'Honda HM (Depuis 1999)',
  'Rieju MRT / MRT Pro (Depuis 2009)',
  'Fantic tout modèle (Depuis 2017)',
  'Derbi Senda (Depuis 2018)',
  'Derbi DRD Racing (Depuis 2018)',
  'Derbi DRD Xtrem (Depuis 2018)',
  'Derbi DRD Evo (2008-2010)',
  'Vent (Tout Modèle) (Depuis 2018)'
];

/* ---------- le produit Shopify ---------- */
var PRODUIT_HANDLE = 'velto-housse-de-selle';
var VARIANTES = [
  52783007695189, 52783007727957, 52783007760725, 52783007793493, 52783007826261,
  52783007859029, 52783007891797, 52783007924565, 52783007957333, 52783007990101,
  52783008022869, 52783008055637, 52783008088405, 52783008121173, 52783008153941,
  52783008186709, 52783008219477, 52783008252245, 54880256917845, 54880257016149,
  54880305348949, 54880305578325, 54880305840469, 54880305873237, 54880306102613
];
var OPT_VAR  = 54868599931221;   /* « Supplément selle velto » à 1 €, brique de prix */
var PACK_VAR = 54119771603285;   /* pack entretien, repris de la Selle Custom */

/* ---------- prix ----------
   164,90 € est le prix de base et les trois bandes en font partie : contrairement
   au scooter, il n'y a pas de mode « sans bandes ». Seules les matières ajoutent.
   Cette valeur DOIT égaler le prix des variantes Shopify, sinon le panier facture
   autre chose que ce que le client voit — le script de déploiement le vérifie. */
var PRIX = {
  base:    164.90,
  brodNum:  20.00,   /* numéro sur le dessus arrière */
  brodPse:  35.00,   /* pseudo sur le flanc */
  nfc:      10.00,
  pack:     17.82
};

/* ---------- position des broderies ----------
   Relevé par le propriétaire avec POSITIONNER LA BRODERIE VELTO.html.
   « max » est la largeur maximale tolérée, en % de l'aperçu : au-delà le texte
   rétrécit au lieu de déborder de la selle. Mesuré : un pseudo de 11 lettres à
   3 cqw fait 38,6 % et sort du flanc, d'où la limite à 28. */
var BROD = {
  num: { left:71.1, top:62.8, taille:3.0, rot:-50, max:12, lim:4  },
  pse: { left:56.0, top:65.1, taille:3.0, rot:37,  max:28, lim:14 }
};

/* Où tombe chaque bande sur la selle. Relevé sur les calques : le logo, qui est
   à l'avant, est en haut à gauche du gabarit ; grip1 en est la bande la plus
   proche, grip3 la plus loin. L'atelier lit ces mots sur la commande. */
var POSE = ['avant', 'milieu', 'arrière'];

/* ---------- rubriques de marque ----------
   Avant, chaque marque avait son propre produit VELTO : le client arrivé par la
   rubrique Rieju ne voyait que les Rieju. Le produit configurable est unique, on
   retrouve donc le découpage ici — la marque se lit dans le titre du modèle, si
   bien qu'un modèle ajouté plus tard tombe tout seul dans la bonne rubrique.
   Contrôlé par velto-verifier-gammes.js : les 25 modèles sont rangés, chacun
   dans une seule rubrique. */
var GAMMES = {
  'collection-50cc-am6-beta-50cc':                  { nom:'Beta',                    mots:['beta'] },
  'collection-50cc-euro-3-derbi-gilera-aprilia-sx': { nom:'Derbi · Gilera · Aprilia', mots:['derbi','gilera','aprilia'] },
  'collection-50cc-am6-dt-mbk-yamaha-50-cc':        { nom:'DT · MBK · Yamaha',       mots:['yamaha','mbk'] },
  'collection-50cc-am6-fantic-50cc':                { nom:'Fantic',                  mots:['fantic'] },
  'collection-50cc-am6-hm-vent-honda-50cc':         { nom:'Honda · HM · Vent',       mots:['honda','hm','vent'] },
  'collection-50cc-am6-rieju-mrt-mrx':              { nom:'Rieju MRT · MRX',         mots:['rieju'] },
  'collection-50cc-am6-sherco':                     { nom:'Sherco',                  mots:['sherco'] }
};
var gamme = null;                     /* la rubrique d'où vient le client, si connue */

function litGamme(){
  try{
    var p = new URLSearchParams(location.search).get('gamme');
    if(p && GAMMES[p]) return p;
    /* Le thème ne met pas la collection dans le lien produit : à défaut on
       regarde d'où le client arrive. Rien de trouvé = les 25 modèles. */
    var m = String(document.referrer || '').match(/\/collections\/([a-z0-9-]+)/i);
    if(m && GAMMES[m[1]]) return m[1];
  }catch(e){}
  return null;
}

function modelesVisibles(){
  if(!gamme) return MODELES;
  var mots = GAMMES[gamme].mots;
  var L = MODELES.filter(function(m){
    var t = m.toLowerCase();
    for(var i = 0; i < mots.length; i++) if(t.indexOf(mots[i]) >= 0) return true;
    return false;
  });
  return L.length ? L : MODELES;      /* jamais de liste vide : mieux vaut tout montrer */
}

/* ---------- logo réseau social brodé ---------- */
var SOC = [['Aucun','aucun',''], ['TikTok','tiktok','social-tiktok'],
           ['Insta','insta','social-insta'], ['Snap','snap','social-snap']];
function nomSoc(k){ for(var i=0;i<SOC.length;i++) if(SOC[i][1] === k) return SOC[i][0]; return ''; }

/* ---------- état ---------- */
var C = {
  modele:  '',
  dessus:  { s:'noir' },
  coteBas: { s:'rouge' },
  coteHaut:{ s:'rouge' },
  insert:  { s:'noir' },
  bandes:  { mode:'uni', s:['blanc','blanc','blanc'] },
  logo:    { s:'blanc' },
  couture: { fil:'Blanc' },
  social:  'aucun',
  brodNum: { t:'', c:'#f2f2f2' },
  brodPse: { t:'', c:'#f2f2f2' },
  nfc:     { on:false, url:'' },
  pack:    false,
  touched: { modele:false, dessus:false, cotes:false, insert:false,
             bandes:false, logo:false, couture:false, brod:false }
};

var STEPS = [
  {ic:'🏍️',lb:'Ta moto'},   {ic:'🎨',lb:'Dessus'},  {ic:'🔻',lb:'Côtés'},
  {ic:'💠',lb:'Insert'},     {ic:'〰️',lb:'Bandes'}, {ic:'🅱️',lb:'Logo'},
  {ic:'🪡',lb:'Couture'},    {ic:'🧵',lb:'Broderies'}, {ic:'🧾',lb:'Récap'}
];

/* ---------- accès au catalogue ---------- */
function $(i){ return document.getElementById(i); }
function eur(n){ return n.toFixed(2).replace('.', ',') + ' €'; }
function liste(zone){ return (FIN && FIN[zone]) || []; }
function fin(zone, slug){
  var l = liste(zone);
  for(var i=0;i<l.length;i++) if(l[i].slug === slug) return l[i];
  return l[0] || { slug:slug, nom:slug, hex:'#666', prix:0, matiere:'Simili' };
}
function nomFin(zone, slug){ return fin(zone, slug).nom; }
function prixFin(zone, slug){ return fin(zone, slug).prix || 0; }
function valide(zone, slug){
  var l = liste(zone);
  for(var i=0;i<l.length;i++) if(l[i].slug === slug) return slug;
  return l.length ? l[0].slug : slug;
}

/* Fond d'une pastille : vraie vignette photo pour les matières, couleur unie
   pour le simili. On reprend celles de FUSION, déjà sur le CDN. */
function vignette(o){
  var b = SCDN + 'fus-sw-';
  if(o.matiere === 'Simili')        return o.hex;
  if(o.matiere === 'Holographique') return 'url(' + b + 'holo.webp) center/cover';
  if(o.matiere === 'Carbone forgé') return 'url(' + b + 'carbone-' + o.couleur + '.webp) center/cover';
  if(o.matiere === 'Carbone')       return 'url(' + b + 'dessus-carbone-' + o.couleur + '.webp) center/cover';
  return 'url(' + b + o.matiere.toLowerCase() + '-' + o.couleur + '.webp) center/cover';
}

function mklabel(t){ var d = document.createElement('div'); d.className = 'lb'; d.textContent = t; return d; }
function touch(k){ C.touched[k] = true; }

/* nuancier d'une zone */
function nuancier(zone, choisi, onpick){
  var w = document.createElement('div'); w.className = 'sws';
  liste(zone).forEach(function(o){
    var x = document.createElement('div'); x.className = 'swx';
    var s = document.createElement('div');
    s.className = 'sw' + (choisi === o.slug ? ' sel' : '');
    s.style.background = vignette(o);
    s.title = o.nom + (o.prix ? '  +' + eur(o.prix) : '');
    s.onclick = function(){ onpick(o.slug); };
    var l = document.createElement('div'); l.className = 'swlab';
    l.textContent = o.nom.replace(/^(Alcantara|Carbone forgé|Carbone|Chrome)\s+/, '');
    x.appendChild(s); x.appendChild(l);
    if(o.prix){ var p = document.createElement('div'); p.className = 'swlab';
                p.style.color = '#cdb6ff'; p.textContent = '+' + o.prix + '€'; x.appendChild(p); }
    w.appendChild(x);
  });
  return w;
}

/* ---------- prix ---------- */
function bandSlug(i){
  if(C.bandes.mode === 'uni')     return C.bandes.s[0];
  if(C.bandes.mode === 'alterne') return C.bandes.s[i % 2];
  return C.bandes.s[i];
}
function pDessus(){ return prixFin('dessus', C.dessus.s); }
function pCotes(){ return prixFin('cote-bas', C.coteBas.s) + prixFin('cote-haut', C.coteHaut.s); }
function pInsert(){ return prixFin('insert', C.insert.s); }
/* comme le scooter : on facture la finition la plus chère parmi les trois bandes */
function pBandes(){
  var mx = 0;
  for(var i=0;i<3;i++) mx = Math.max(mx, prixFin('grip' + (i+1), bandSlug(i)));
  return mx;
}
function pBrodNum(){ return C.brodNum.t.trim() ? PRIX.brodNum : 0; }
function pBrodPse(){ return C.brodPse.t.trim() ? PRIX.brodPse : 0; }
function pNfc(){ return C.nfc.on ? PRIX.nfc : 0; }
function pPack(){ return C.pack ? PRIX.pack : 0; }
function total(){
  return PRIX.base + pDessus() + pCotes() + pInsert() + pBandes()
       + pBrodNum() + pBrodPse() + pNfc() + pPack();
}
function variante(){ var i = MODELES.indexOf(C.modele); return i < 0 ? 0 : VARIANTES[i]; }

/* ---------- aperçu ---------- */
function paint(){
  /* On ne remplace le calque qu'une fois la nouvelle image chargée : sinon
     l'ancienne disparaît le temps du téléchargement et la selle « saute ». */
  function set(id, zone, slug){
    var e = $(id), u = urlCalque(zone, slug);
    if(e.getAttribute('src') === u){ e.style.display = ''; return; }
    var pre = new Image();
    pre.onload  = function(){ e.src = u; e.style.display = ''; };
    pre.onerror = function(){ e.style.display = 'none'; };
    pre.src = u;
  }
  set('L_base',      'base',      'base');
  set('L_dessus',    'dessus',    C.dessus.s);
  set('L_cote-bas',  'cote-bas',  C.coteBas.s);
  set('L_cote-haut', 'cote-haut', C.coteHaut.s);
  set('L_insert',    'insert',    C.insert.s);
  for(var i=1;i<=3;i++) set('L_grip'+i, 'grip'+i, bandSlug(i-1));
  set('L_logo',      'logo',      C.logo.s);
  peindreBrod('B_num', BROD.num, C.brodNum);
  peindreBrod('B_pse', BROD.pse, C.brodPse);

  $('wm').textContent = C.modele ? C.modele.split(' ')[0].toUpperCase() : 'VELTO';
  var t = eur(total());
  $('fly').textContent = t;
  var tv = $('tot');
  if(tv.textContent !== t){ tv.textContent = t; tv.classList.add('bump');
    setTimeout(function(){ tv.classList.remove('bump'); }, 200); }
  $('stp').textContent = 'Étape ' + (cur+1) + '/' + STEPS.length;
  $('bn').textContent  = (cur === STEPS.length-1) ? '🛒 Ajouter au panier' : 'Suivant →';

  var pl = $('pills'); pl.innerHTML = '';
  STEPS.forEach(function(s, i){
    var b = document.createElement('button');
    b.className = 'pill' + (i === cur ? ' act' : '') + (stepDone(i) ? ' done' : '');
    b.innerHTML = s.ic + ' ' + s.lb;
    b.onclick = function(){ cur = i; render(); };
    pl.appendChild(b);
  });
  if(pl.children[cur]){
    if(!pl.dataset.molette){
      pl.dataset.molette = '1';
      pl.addEventListener('wheel', function(e){
        if(pl.scrollWidth <= pl.clientWidth) return;
        var d = Math.abs(e.deltaY) > Math.abs(e.deltaX) ? e.deltaY : e.deltaX;
        if(!d) return;
        pl.scrollLeft += d; e.preventDefault();
      }, { passive:false });
    }
    centrerPastille();
  }
}

/* recentre la pastille active sans faire bouger la page verticalement */
function centrerPastille(){
  var pl = $('pills'), act = pl && pl.children[cur];
  if(!act) return;
  var maxi = pl.scrollWidth - pl.clientWidth;
  pl.classList.toggle('defile', maxi > 0);
  if(maxi > 0){
    var rb = pl.getBoundingClientRect(), ra = act.getBoundingClientRect();
    var vise = pl.scrollLeft + (ra.left - rb.left) - (pl.clientWidth - ra.width) / 2;
    pl.scrollLeft = Math.max(0, Math.min(maxi, vise));
  } else pl.scrollLeft = 0;
  majRail();
}

/* ---------- broderies ---------- */
/* le texte rétrécit tout seul pour tenir dans sa largeur, comme une vraie broderie */
function fitBrod(el, taille, maxPct){
  var L = $('stage').clientWidth || 520;
  el.style.fontSize = (taille/100*L) + 'px';
  var w = el.scrollWidth, maxPx = maxPct/100*L;
  if(w > maxPx) el.style.fontSize = ((taille*maxPx/w)/100*L) + 'px';
}
function peindreBrod(id, pos, etat){
  var el = $(id), t = (etat.t||'').trim();
  if(!t){ el.style.display = 'none'; return; }
  el.textContent = t.slice(0, pos.lim);
  el.setAttribute('style', 'display:block;left:' + pos.left + '%;top:' + pos.top + '%;'
    + 'transform:translate(-50%,-50%) rotate(' + pos.rot + 'deg);'
    + 'color:' + etat.c + ';text-shadow:0 1px 2px rgba(0,0,0,.5);');
  fitBrod(el, pos.taille, pos.max);
}
function refitBrod(){
  peindreBrod('B_num', BROD.num, C.brodNum);
  peindreBrod('B_pse', BROD.pse, C.brodPse);
}
window.addEventListener('resize', function(){ refitBrod(); centrerPastille(); });
if(document.fonts && document.fonts.ready) document.fonts.ready.then(refitBrod);

/* ---------- barre de défilement des étapes ---------- */
function majRail(){
  var pl = $('pills'), w = $('railwrap'), th = $('rthumb');
  if(!pl || !w || !th) return;
  var maxi = pl.scrollWidth - pl.clientWidth;
  w.classList.toggle('on', maxi > 0);
  if(maxi <= 0) return;
  var rail = th.parentNode.clientWidth;
  var larg = Math.max(26, Math.round(rail * pl.clientWidth / pl.scrollWidth));
  th.style.width = larg + 'px';
  th.style.left  = Math.round((rail - larg) * (pl.scrollLeft / maxi)) + 'px';
}
(function(){
  var pl = $('pills'), rail = $('rthumb') && $('rthumb').parentNode;
  if(!pl || !rail) return;
  pl.addEventListener('scroll', majRail, { passive:true });
  window.addEventListener('resize', majRail);
  var tire = false;
  function aller(e){
    var t = e.touches ? e.touches[0] : e;
    var r = rail.getBoundingClientRect();
    var k = Math.max(0, Math.min(1, (t.clientX - r.left) / r.width));
    pl.scrollLeft = k * (pl.scrollWidth - pl.clientWidth);
  }
  rail.addEventListener('pointerdown', function(e){ tire = true; aller(e); });
  window.addEventListener('pointermove', function(e){ if(tire) aller(e); });
  window.addEventListener('pointerup', function(){ tire = false; });
})();

/* ---------- rendu des étapes ---------- */
var cur = 0;
var dernierStep = -1;

function render(){
  var y = window.scrollY;
  var memeEtape = (cur === dernierStep);
  var p = $('pane'); p.innerHTML = '';

  /* ---- 0 · la moto ---- */
  if(cur === 0){
    p.innerHTML = '<h2>Ta moto 🏍️</h2>'
                + '<div class="sub">On découpe la housse au patron exact de ton modèle.</div>';
    p.appendChild(mklabel('Modèle'));
    var liste = modelesVisibles();
    var sel = document.createElement('select');
    sel.innerHTML = '<option value="">— choisis ton modèle —</option>'
      + liste.map(function(m){ return '<option' + (C.modele === m ? ' selected' : '') + '>' + m + '</option>'; }).join('');
    sel.onchange = function(){ C.modele = this.value; touch('modele'); render(); };
    p.appendChild(sel);

    /* Le client vient d'une rubrique de marque : on ne lui montre que ses motos,
       comme le faisaient les anciens produits par marque. La sortie de secours
       reste visible — il a pu se tromper de rubrique. */
    if(gamme && liste.length < MODELES.length){
      var g = document.createElement('div'); g.className = 'note';
      g.innerHTML = 'Rubrique <b>' + GAMMES[gamme].nom + '</b> — '
        + liste.length + (liste.length > 1 ? ' modèles' : ' modèle')
        + '. <a href="#" id="toutmodele" style="color:inherit">Voir les '
        + MODELES.length + ' modèles</a>';
      p.appendChild(g);
      $('toutmodele').onclick = function(e){ e.preventDefault(); gamme = null; render(); };
    }

    var n = document.createElement('div'); n.className = 'note';
    n.textContent = 'Tu ne trouves pas ta moto ? Écris-nous, on fabrique sur mesure.';
    p.appendChild(n);
  }

  /* ---- 1 · dessus ---- */
  else if(cur === 1){
    p.innerHTML = '<h2>Le dessus 🎨</h2>'
                + '<div class="sub">La grande surface, celle qu’on voit en premier. '
                + 'L’alcantara accroche mieux et ne brille pas au soleil.</div>';
    p.appendChild(mklabel('Matière et couleur'));
    p.appendChild(nuancier('dessus', C.dessus.s, function(v){ C.dessus.s = v; touch('dessus'); render(); }));
  }

  /* ---- 2 · côtés ---- */
  else if(cur === 2){
    p.innerHTML = '<h2>Les côtés 🔻</h2>'
                + '<div class="sub">Deux bandeaux superposés sur le flanc. Même couleur pour un bloc net, '
                + 'deux couleurs pour souligner la ligne.</div>';
    p.appendChild(mklabel('Côté haut'));
    p.appendChild(nuancier('cote-haut', C.coteHaut.s, function(v){ C.coteHaut.s = v; touch('cotes'); render(); }));
    p.appendChild(mklabel('Côté bas'));
    p.appendChild(nuancier('cote-bas', C.coteBas.s, function(v){ C.coteBas.s = v; touch('cotes'); render(); }));
    var na = document.createElement('div'); na.className = 'note';
    na.innerHTML = (C.coteHaut.s === C.coteBas.s)
      ? 'Les deux côtés sont assortis : la selle paraît plus longue.'
      : 'Deux teintes différentes : le flanc se lit en deux traits.';
    p.appendChild(na);
  }

  /* ---- 3 · insert ---- */
  else if(cur === 3){
    p.innerHTML = '<h2>L’insert 💠</h2>'
                + '<div class="sub">La petite pièce du flanc. C’est là qu’on ose : chrome, carbone forgé '
                + 'ou holographique y coûtent moins cher qu’ailleurs, la surface est réduite.</div>';
    p.appendChild(mklabel('Matière et couleur'));
    p.appendChild(nuancier('insert', C.insert.s, function(v){ C.insert.s = v; touch('insert'); render(); }));
  }

  /* ---- 4 · bandes ---- */
  else if(cur === 4){
    p.innerHTML = '<h2>Les bandes 〰️</h2>'
                + '<div class="sub">Les trois bandes grip du dessus. Toutes pareilles, en alternance, '
                + 'ou une couleur par bande.</div>';
    p.appendChild(mklabel('Style des bandes'));
    /* meme barre que la FUSION et le scooter : .toggle / button.sel. Les classes
       .seg et .segb n'existent nulle part dans la feuille de style — les boutons
       sortaient nus, trois blocs blancs colles les uns aux autres. */
    var tb = document.createElement('div'); tb.className = 'toggle';
    [['uni','Uni'],['alterne','Alterné 🔁'],['bande','Par bande']].forEach(function(m){
      var b = document.createElement('button');
      b.className = (C.bandes.mode === m[0] ? 'sel' : '');
      b.innerHTML = m[1] + '<span style="display:block;font-size:10.5px;opacity:.75">inclus</span>';
      b.onclick = function(){ C.bandes.mode = m[0]; touch('bandes'); render(); };
      tb.appendChild(b);
    });
    p.appendChild(tb);

    var n = C.bandes.mode === 'uni' ? 1 : (C.bandes.mode === 'alterne' ? 2 : 3);
    for(var k = 0; k < n; k++){
      (function(idx){
        p.appendChild(mklabel(n === 1 ? 'Couleur des trois bandes'
                    : (C.bandes.mode === 'alterne' ? 'Couleur ' + (idx+1)
                    : 'Bande ' + (idx+1) + ' (' + POSE[idx] + ')')));
        p.appendChild(nuancier('grip' + (idx+1 > 3 ? 3 : idx+1), C.bandes.s[idx], function(v){
          C.bandes.s[idx] = v;
          if(C.bandes.mode === 'uni'){ C.bandes.s[1] = v; C.bandes.s[2] = v; }
          touch('bandes'); render();
        }));
      })(k);
    }
    var nb = document.createElement('div'); nb.className = 'note';
    nb.innerHTML = 'Une seule matière est facturée, la plus chère des trois — pas trois fois.';
    p.appendChild(nb);
  }

  /* ---- 5 · logo + puce NFC ---- */
  else if(cur === 5){
    p.innerHTML = '<h2>Le logo BKS 🅱️</h2>'
                + '<div class="sub">Brodé à l’avant : c’est lui qui signe la selle. '
                + 'Ton sur ton pour rester sobre, ou franc pour qu’on le voie de loin.</div>';
    p.appendChild(mklabel('Couleur du logo'));
    p.appendChild(nuancier('logo', C.logo.s, function(v){ C.logo.s = v; touch('logo'); render(); }));
    p.appendChild(nfcBox());
    $('nfcsw').parentNode.onclick = function(){ C.nfc.on = !C.nfc.on; render(); };
    if(C.nfc.on){
      var nu = $('nfcu'); nu.value = C.nfc.url;
      nu.oninput = function(){ C.nfc.url = this.value; nfcHint(); };
      nfcHint();
    }
  }

  /* ---- 6 · couture ---- */
  else if(cur === 6){
    p.innerHTML = '<h2>La couture 🪡</h2>'
                + '<div class="sub">Le fil suit toutes les lignes de la selle. Assorti, il disparaît ; '
                + 'contrasté, il redessine la forme.</div>';
    p.appendChild(mklabel('Couleur du fil'));
    var w = document.createElement('div'); w.className = 'sws';
    FILS.forEach(function(f){
      var x = document.createElement('div'); x.className = 'swx';
      var s = document.createElement('div');
      s.className = 'sw' + (C.couture.fil === f[0] ? ' sel' : '');
      s.style.background = f[1] + ' url(' + SCDN + 'sc-coutures-' + f[2] + '.webp) center/cover';
      s.title = f[0];
      s.onclick = function(){ C.couture.fil = f[0]; touch('couture'); render(); };
      var l = document.createElement('div'); l.className = 'swlab'; l.textContent = f[0];
      x.appendChild(s); x.appendChild(l); w.appendChild(x);
    });
    p.appendChild(w);
    var n2 = document.createElement('div'); n2.className = 'note';
    n2.innerHTML = '🪡 Le fil ne se voit pas sur l’aperçu, mais ton choix part bien à l’atelier.';
    p.appendChild(n2);
  }

  /* ---- 7 · broderies ---- */
  else if(cur === 7){
    p.innerHTML = '<h2>Les broderies 🧵</h2>'
                + '<div class="sub">Ton numéro sur le dessus arrière, ton pseudo sur le flanc. '
                + 'Au fil, pas imprimé : ça ne s’effacera jamais.</div>';

    function boiteBrod(titre, prix, etat, ph, lim){
      var box = document.createElement('div'); box.className = 'brodbox';
      box.innerHTML = '<div class="bt"><span>' + titre + '</span><span class="bp">+' + eur(prix) + '</span></div>';
      var inp = document.createElement('input');
      inp.type = 'text'; inp.maxLength = lim; inp.placeholder = ph; inp.value = etat.t;
      inp.oninput = function(){ etat.t = this.value; paint(); };
      box.appendChild(inp);
      box.appendChild(mklabel('Couleur du fil'));
      var w = document.createElement('div'); w.className = 'sws';
      FILBROD.forEach(function(f){
        var s = document.createElement('div');
        s.className = 'sw mini' + (etat.c === f[1] ? ' sel' : '');
        s.style.background = f[1];
        s.title = f[0];
        s.onclick = function(){ etat.c = f[1]; render(); };
        w.appendChild(s);
      });
      box.appendChild(w);
      p.appendChild(box);
    }

    boiteBrod('Numéro — dessus arrière', PRIX.brodNum, C.brodNum, 'Ex : 04', BROD.num.lim);

    /* logo réseau social brodé, comme sur FUSION — offert, non visible sur l'aperçu */
    p.appendChild(mklabel('Logo réseau social (brodé)'));
    var sr = document.createElement('div'); sr.className = 'sws';
    SOC.forEach(function(s){
      var x = document.createElement('div'); x.className = 'swx';
      var d = document.createElement('div'); d.className = 'sw' + (C.social === s[1] ? ' sel' : '');
      if(s[2]) d.setAttribute('style', 'background:#fff url(' + UI + s[2] + '.webp' + VER + ') center/72% no-repeat;');
      else { d.setAttribute('style', 'display:flex;align-items:center;justify-content:center;color:#8a8a8a;font-size:18px;'); d.textContent = '∅'; }
      d.onclick = function(){ C.social = s[1]; render(); };
      var l = document.createElement('div'); l.className = 'swlab'; l.textContent = s[0];
      x.appendChild(d); x.appendChild(l); sr.appendChild(x);
    });
    p.appendChild(sr);
    var sh = document.createElement('div'); sh.className = 'note'; sh.style.margin = '6px 0 12px';
    sh.textContent = 'Le logo choisi est brodé sur la selle (non affiché sur l’aperçu).';
    p.appendChild(sh);

    boiteBrod('Pseudo — flanc', PRIX.brodPse, C.brodPse, 'Ex : TON PSEUDO', BROD.pse.lim);

    var nb2 = document.createElement('div'); nb2.className = 'note';
    nb2.innerHTML = 'Laisse vide si tu n’en veux pas — rien n’est facturé.';
    p.appendChild(nb2);
    C.touched.brod = true;   /* étape facultative : l’avoir vue suffit à la valider */
  }

  /* ---- 8 · récap ---- */
  else {
    p.innerHTML = '<h2>Ta selle 🧾</h2><div class="sub">Vérifie avant d’ajouter au panier.</div>';
    var box = document.createElement('div'); box.className = 'recap';
    lignes().forEach(function(l){
      var r = document.createElement('div'); r.className = 'rl';
      r.innerHTML = '<span>' + l[0] + '</span><b>' + l[1] + '</b>';
      box.appendChild(r);
    });
    var det = [['Housse sur mesure', eur(PRIX.base)]];
    if(pDessus())  det.push(['Matière du dessus', '+ ' + eur(pDessus())]);
    if(pCotes())   det.push(['Matière des côtés', '+ ' + eur(pCotes())]);
    if(pInsert())  det.push(['Matière de l’insert', '+ ' + eur(pInsert())]);
    if(pBandes())  det.push(['Matière des bandes', '+ ' + eur(pBandes())]);
    if(pBrodNum()) det.push(['Broderie numéro', '+ ' + eur(pBrodNum())]);
    if(pBrodPse()) det.push(['Broderie pseudo', '+ ' + eur(pBrodPse())]);
    if(pNfc())     det.push(['Puce NFC', '+ ' + eur(pNfc())]);
    if(pPack())    det.push(['Pack entretien', '+ ' + eur(pPack())]);
    det.forEach(function(d){
      var r = document.createElement('div'); r.className = 'rl';
      r.innerHTML = '<span>' + d[0] + '</span><b>' + d[1] + '</b>';
      box.appendChild(r);
    });
    var tr = document.createElement('div'); tr.className = 'rr';
    tr.innerHTML = '<span style="font-weight:800">Total</span><b style="font-size:17px">' + eur(total()) + '</b>';
    box.appendChild(tr);
    p.appendChild(box);

    var up = document.createElement('div'); up.className = 'upsell';
    up.innerHTML = '<div class="ubadge">🔥 -10% à ne pas manquer</div>'
      + '<div class="uimg" style="background-image:url(' + SCDN + 'sc-accessoires-pack-nettoyage.webp)"></div>'
      + '<div class="ubody"><div class="utitle">Pack entretien — garde ta selle comme au premier jour ✨</div>'
      + '<div class="usub">2 microfibres + nettoyant simili/alcantara + nourrissant simili.</div>'
      + '<div class="uprice"><s>19,80 €</s>' + eur(PRIX.pack) + '</div></div>'
      + '<button class="ubtn" id="upb">' + (C.pack ? '✓ Ajouté' : '+ Ajouter') + '</button>';
    p.appendChild(up);
    $('upb').onclick = function(){ C.pack = !C.pack; render(); };
  }

  paint();

  /* On ne bouge la page que si l'on change d'étape, et jamais au-delà du bas. */
  if(!memeEtape){
    var maxY = Math.max(0, document.documentElement.scrollHeight - window.innerHeight);
    window.scrollTo(0, Math.min(y, maxY));
  } else {
    var maxY2 = Math.max(0, document.documentElement.scrollHeight - window.innerHeight);
    window.scrollTo(0, Math.min(y, maxY2));
  }
  dernierStep = cur;
}

/* ---------- puce NFC ---------- */
function validNfcUrl(u){ return /^https:\/\/[^\s]+\.[^\s]{2,}/.test(String(u||'').trim()); }
function nfcHint(){
  var h = $('nfchint'); if(!h) return;
  var u = (C.nfc.url||'').trim();
  if(!u){ h.className = 'nfchint'; h.textContent = 'Colle le lien que la puce doit ouvrir.'; return; }
  if(validNfcUrl(u)){ h.className = 'nfchint ok'; h.innerHTML = '✓ Lien valide — le téléphone sera redirigé ici.'; }
  else { h.className = 'nfchint err'; h.innerHTML = '⚠️ Lien incomplet : il doit commencer par <b>https://</b> '
    + 'et contenir un point (ex : https://instagram.com/…).'; }
}
/* Encadré NFC repris tel quel de la FUSION et du scooter : .nfcbox, son liseré
   violet et son badge NOUVEAU. Les classes .nfc / .nfctitle / .nfcsub d'avant
   n'existaient pas dans la feuille de style, le bloc sortait transparent. */
function nfcBox(){
  var box = document.createElement('div'); box.className = 'nfcbox';
  box.innerHTML = '<span class="nfcnew">✨ NOUVEAU</span>'
    + '<div class="nfchead"><div class="nfcic">📲</div>'
    + '<div class="nfctxt"><div class="nfct">Puce NFC connectée <span class="nfcp">+' + eur(PRIX.nfc) + '</span></div>'
    + '<div class="nfcd">Une puce invisible, glissée <b>derrière le logo BKS à l’avant</b> : on pose son téléphone '
    + 'dessus et hop — redirection directe vers le lien de ton choix (Insta, site, playlist, avis Google…).<br>'
    + '🔄 <b>Le lien n’est pas définitif</b> : tu pourras le changer toi-même quand tu veux, '
    + 'avec une appli NFC gratuite sur ton téléphone.</div></div>'
    + '<div class="switch' + (C.nfc.on ? ' on' : '') + '" id="nfcsw"></div></div>';
  if(C.nfc.on){
    var w = document.createElement('div'); w.className = 'nfcurl';
    w.innerHTML = '<input type="url" id="nfcu" inputmode="url" autocapitalize="off" autocomplete="off" '
      + 'spellcheck="false" placeholder="https://instagram.com/ton_compte">'
      + '<div class="nfchint" id="nfchint"></div>';
    box.appendChild(w);
  }
  return box;
}

/* ---------- récapitulatif ---------- */
function lignes(){
  var L = [];
  L.push(['Modèle', C.modele || '—']);
  L.push(['Dessus', nomFin('dessus', C.dessus.s)]);
  L.push(['Côté haut', nomFin('cote-haut', C.coteHaut.s)]);
  L.push(['Côté bas', nomFin('cote-bas', C.coteBas.s)]);
  L.push(['Insert', nomFin('insert', C.insert.s)]);
  if(C.bandes.mode === 'uni') L.push(['Bandes', 'Uni · ' + nomFin('grip1', C.bandes.s[0])]);
  else if(C.bandes.mode === 'alterne')
    L.push(['Bandes', 'Alterné · ' + nomFin('grip1', C.bandes.s[0]) + ' / ' + nomFin('grip2', C.bandes.s[1])]);
  /* On nomme la place de chaque bande, pas seulement son rang : c'est cette ligne
     que l'atelier lit sur la commande, et « bande 2 » tout seul ne dit pas dans
     quel sens compter. Ordre vérifié sur les calques — grip1 est la bande la plus
     proche du logo, donc l'avant. */
  else L.push(['Bandes', 'Par bande · ' + [0,1,2].map(function(i){
    return POSE[i] + ' : ' + nomFin('grip'+(i+1), C.bandes.s[i]); }).join(' · ')]);
  L.push(['Logo BKS', nomFin('logo', C.logo.s)]);
  L.push(['Fil de couture', C.couture.fil]);
  var nomFil = nomFilBrod;   /* les broderies lisent la palette FUSION, pas les surpiqûres */
  if(C.social !== 'aucun') L.push(['Logo réseau brodé', nomSoc(C.social)]);
  if(C.brodNum.t.trim()) L.push(['Broderie numéro', '« ' + C.brodNum.t.trim() + ' » · fil ' + nomFil(C.brodNum.c)]);
  if(C.brodPse.t.trim()) L.push(['Broderie pseudo', '« ' + C.brodPse.t.trim() + ' » · fil ' + nomFil(C.brodPse.c)]);
  if(C.nfc.on) L.push(['Puce NFC 📲', C.nfc.url || '—']);
  if(C.pack)   L.push(['Pack entretien', eur(PRIX.pack)]);
  return L;
}

/* ---------- avancement ---------- */
function stepDone(i){
  if(i === 0) return C.touched.modele && !!C.modele;
  if(i === 1) return C.touched.dessus;
  if(i === 2) return C.touched.cotes;
  if(i === 3) return C.touched.insert;
  if(i === 4) return C.touched.bandes;
  if(i === 5) return C.touched.logo;
  if(i === 6) return C.touched.couture;
  if(i === 7) return C.touched.brod;
  return false;
}
function manque(){
  if(!C.modele)          return { step:0, msg:'Choisis ton modèle de moto 🏍️' };
  if(!C.touched.dessus)  return { step:1, msg:'Choisis la matière et la couleur du dessus 🎨' };
  if(!C.touched.cotes)   return { step:2, msg:'Choisis les couleurs des côtés 🔻' };
  if(!C.touched.insert)  return { step:3, msg:'Choisis la finition de l’insert 💠' };
  if(!C.touched.bandes)  return { step:4, msg:'Choisis le style des bandes 〰️' };
  if(!C.touched.logo)    return { step:5, msg:'Choisis la couleur du logo 🅱️' };
  if(!C.touched.couture) return { step:6, msg:'Choisis la couleur du fil de couture 🪡' };
  return null;
}

/* ---------- ajout au panier ----------
   Même mécanique que le scooter : la selle au prix de base, puis la brique
   « Options » à 1 € en quantité = nombre d'euros de suppléments. Les lignes sont
   reliées par _bks_id ; bks-cart-guard.js les fait vivre et mourir ensemble. */
function props(id){
  var p = {};
  lignes().forEach(function(l){ p[l[0]] = l[1]; });
  delete p['Pack entretien'];
  p['_bks_id'] = id;
  p['_bks_role'] = 'base';
  return p;
}
function addToCart(){
  var m = manque();
  if(m){ cur = m.step; render(); window.scrollTo({ top:0, behavior:'smooth' }); alert(m.msg); return; }
  if(C.nfc.on && !validNfcUrl(C.nfc.url)){
    cur = 5; render(); window.scrollTo({ top:0, behavior:'smooth' });
    var u = $('nfcu'); if(u) u.focus();
    alert('📲 Ajoute le lien https:// de ta puce NFC (ou désactive l’option).'); return;
  }
  var v = variante();
  if(!v){ cur = 0; render(); alert('Choisis ton modèle de moto 🏍️'); return; }

  var supp = Math.round(total() - PRIX.base - pPack());
  if(supp > 0 && !OPT_VAR){
    alert('La brique de prix des options n’est pas configurée. Préviens-nous.'); return;
  }
  var id = 'VLT-' + Date.now();
  var items = [{ id:v, quantity:1, properties:props(id) }];
  if(supp > 0) items.push({ id:OPT_VAR, quantity:supp, properties:{
    '_bks_id':id, '_bks_role':'brick', 'Détail':'Options & finitions (+' + supp + ' €)' } });
  if(C.pack) items.push({ id:PACK_VAR, quantity:1, properties:{
    '_bks_id':id, '_bks_role':'supp', 'Détail':'Pack entretien' } });
  items[0].properties['_bks_parts']    = String(items.length);
  items[0].properties['_bks_brickqty'] = String(supp > 0 ? supp : 0);

  var btn = $('bn'); btn.disabled = true; btn.textContent = 'Ajout…';
  fetch('/cart/add.js', { method:'POST', headers:{ 'Content-Type':'application/json' },
                          body: JSON.stringify({ items:items }) })
    .then(function(r){ if(!r.ok) return r.text().then(function(t){ throw new Error(t); });
                       window.location.href = '/cart'; })
    .catch(function(){ btn.disabled = false; btn.textContent = '🛒 Ajouter au panier';
                       alert('L’ajout au panier a échoué. Réessaie, et préviens-nous si ça persiste.'); });
}

/* ---------- navigation ---------- */
$('bp').onclick = function(){ if(cur > 0){ cur--; render(); } };
$('bn').onclick = function(){
  if(cur < STEPS.length-1){ cur++; render(); return; }
  addToCart();
};


/* ============================================================
   GÉNÉRATEUR DE SELLE

   Même principe que sur le scooter. Le client ne donne pas un sac de couleurs :
   il RANGE celles de sa moto, de la plus présente à la moins présente, et la
   selle est composée dans le même ordre. Il retrouve donc l'équilibre de sa
   moto, au lieu de « du rouge et du bleu » sans savoir lequel domine.

   Les parts viennent de mesurer-surfaces-zones.js, qui compte les pixels
   VISIBLES des calques une fois empilés — pas une estimation à l'œil.
   Sur la VELTO : dessus 55,7 % · côtés 25,8 + 8,3 = 34,1 % · bandes 5,7 %
   · insert 2,1 %.
   ============================================================ */
var genC = [null, null, null];                       /* 0 = la plus présente */
var SURF = { dessus:55.7, cotes:34.1, petites:7.8 };  /* bandes + insert */

function parMatiere(zone, mat){
  return liste(zone).filter(function(o){ return o.matiere === mat; });
}
function cherche(zone, mat, couleur){
  var l = parMatiere(zone, mat);
  for(var i = 0; i < l.length; i++) if(l[i].couleur === couleur) return l[i].slug;
  return null;
}
/* valide() de la VELTO retombe sur la PREMIÈRE finition de la zone, pas sur la
   même couleur : ici on veut garder la couleur du client coûte que coûte. */
function similiDe(zone, couleur){ return cherche(zone, 'Simili', couleur) || valide(zone, couleur); }
function paletteSimili(){ return parMatiere('dessus', 'Simili'); }
function nomCoul(c){ var s = cherche('dessus', 'Simili', c); return s ? fin('dessus', s).nom : c; }
function logoSur(c){ return (c === 'blanc' || c === 'jaune' || c === 'gris' || c === 'or') ? 'noir' : 'blanc'; }

function renderGenRow(elId, rang){
  var el = $(elId); if(!el) return; el.innerHTML = '';
  paletteSimili().forEach(function(o){
    var w = document.createElement('div'); w.className = 'swx';
    var s = document.createElement('div');
    s.className = 'sw' + (genC[rang] === o.couleur ? ' sel' : '');
    s.style.background = o.hex; s.title = o.nom;
    s.onclick = function(){
      if(genC[rang] === o.couleur) genC[rang] = null;
      else {
        /* une couleur ne peut pas tenir deux rangs à la fois : on la libère */
        for(var i = 0; i < 3; i++) if(genC[i] === o.couleur) genC[i] = null;
        genC[rang] = o.couleur;
      }
      renderGen();
    };
    var l = document.createElement('div'); l.className = 'swlab'; l.textContent = o.nom;
    w.appendChild(s); w.appendChild(l); el.appendChild(w);
  });
}
function renderGen(){ for(var i = 0; i < 3; i++) renderGenRow('genc' + (i+1), i); }

/* ---- les trois paliers de prix ----
   Un palier n'impose JAMAIS une couleur : il autorise des matières. Si la couleur
   voulue n'existe pas dans la matière du palier, on retombe sur le simili de
   CETTE couleur — le classement du client passe avant la matière, sinon la selle
   ne ressemblerait plus à sa moto. Les côtés n'ont que du simili sur la VELTO :
   la deuxième couleur est donc toujours rendue telle quelle. */
var PALIERS = [
  { id:'essentielle', badge:'ESSENTIELLE', titre:'Le meilleur prix',
    mat:{ dessus:[], insert:[], bande:[] } },
  { id:'equilibree', badge:'ÉQUILIBRÉE', titre:'Le bon compromis',
    mat:{ dessus:['Carbone'], insert:['Carbone forgé','Carbone'],
          bande:['Carbone forgé','Carbone','Alcantara'] } },
  { id:'signature', badge:'SIGNATURE', titre:'Tout ce qu’on sait faire',
    mat:{ dessus:['Alcantara'], insert:['Chrome','Holographique'],
          bande:['Chrome','Holographique'] } }
];

/* Les paliers sont CUMULATIFS : un palier reprend les matières de ceux d'en
   dessous en dernier recours. Sans ça, une couleur sans chrome ferait retomber
   la SIGNATURE en simili alors que l'ÉQUILIBRÉE lui trouvait du carbone : la
   selle la plus chère sortirait moins belle que l'autre. */
function matsPalier(i, cle){
  var l = [];
  for(var k = i; k >= 0; k--) l = l.concat(PALIERS[k].mat[cle]);
  return l.filter(function(v, j, a){ return a.indexOf(v) === j; });
}

/* la plus belle finition DISPONIBLE pour cette couleur ; à défaut son simili */
function finPour(zone, couleur, mats){
  for(var i = 0; i < mats.length; i++){
    var s = cherche(zone, mats[i], couleur);
    if(s) return s;
  }
  return similiDe(zone, couleur);
}

/* Les trois couleurs à placer. Le client peut n'en donner qu'une ou deux : on
   complète sans jamais casser son classement — la 1re reste la plus visible. */
function genCouleurs(){
  var a = genC.filter(Boolean);
  if(!a.length) return null;
  if(a.length === 3) return a;
  if(a.length === 2) return [a[0], a[1], a[1]];   /* la 2e prend côtés ET petites pièces */
  return [a[0], a[0], logoSur(a[0])];             /* une seule : bandes en contraste */
}

function cfgPrice(c){
  var mx = 0;
  for(var i = 0; i < 3; i++) mx = Math.max(mx, prixFin('grip' + (i+1), c.b[i]));
  return PRIX.base + prixFin('dessus', c.dessus)
       + prixFin('cote-bas', c.coteBas) + prixFin('cote-haut', c.coteHaut)
       + prixFin('insert', c.insert) + mx;      /* une seule matière de bande facturée */
}

function composer(p, rang){
  var c = genCouleurs(); if(!c) return null;
  var mD = matsPalier(rang, 'dessus'), mI = matsPalier(rang, 'insert'), mB = matsPalier(rang, 'bande');
  var cfg = {
    dessus:   finPour('dessus', c[0], mD),
    coteHaut: similiDe('cote-haut', c[1]),
    coteBas:  similiDe('cote-bas',  c[1]),
    insert:   finPour('insert', c[2], mI),
    b:        [0,1,2].map(function(i){ return finPour('grip' + (i+1), c[2], mB); }),
    logo:     valide('logo', logoSur(c[0]))     /* le logo est sur le nez, donc sur le dessus */
  };
  cfg.price = cfgPrice(cfg);
  return { id:p.id, badge:p.badge, titre:p.titre, cfg:cfg };
}

/* ce que le palier apporte vraiment, matière par matière — sinon le client lit
   « bandes chrome » sur une selle où le chrome n'existait pas dans sa couleur */
function matieresDe(x){
  var c = x.cfg, m = [];
  var md = fin('dessus', c.dessus).matiere;  if(md !== 'Simili') m.push('dessus ' + md.toLowerCase());
  var mi = fin('insert', c.insert).matiere;  if(mi !== 'Simili') m.push('insert ' + mi.toLowerCase());
  var mb = fin('grip1',  c.b[0]).matiere;    if(mb !== 'Simili') m.push('bandes ' + mb.toLowerCase());
  return m.length ? m.join(' · ') : 'simili-cuir sur toute la selle';
}

function miniPreview(c){
  function u(z, s){ return urlCalque(z, s); }
  return '<img src="' + u('base', 'base') + '" alt="">'
       + '<img src="' + u('dessus', c.dessus) + '" alt="">'
       + '<img src="' + u('cote-bas', c.coteBas) + '" alt="">'
       + '<img src="' + u('cote-haut', c.coteHaut) + '" alt="">'
       + '<img src="' + u('insert', c.insert) + '" alt="">'
       + '<img src="' + u('grip1', c.b[0]) + '" alt="">'
       + '<img src="' + u('grip2', c.b[1]) + '" alt="">'
       + '<img src="' + u('grip3', c.b[2]) + '" alt="">'
       + '<img src="' + u('logo', c.logo) + '" alt="">';
}

function resume(c){
  return 'Dessus <b>' + nomFin('dessus', c.dessus) + '</b>'
       + ' · côtés <b>' + nomFin('cote-haut', c.coteHaut) + '</b>'
       + ' · insert <b>' + nomFin('insert', c.insert) + '</b>'
       + ' · bandes <b>' + nomFin('grip1', c.b[0]) + '</b>';
}

function carte(x, cls){
  var c = x.cfg;
  return '<div class="prop' + cls + '"><span class="pb">' + x.badge + '</span>'
       + '<h4>' + x.titre + '</h4><div class="pl">' + matieresDe(x) + '</div>'
       + '<div class="pv">' + miniPreview(c) + '</div>'
       + '<div class="rsm">' + resume(c) + '</div>'
       + '<div class="foot"><span class="prix">' + eur(c.price) + '</span>'
       + '<button class="papp" id="ap-' + x.id + '">J’applique →</button></div></div>';
}

function lier(x){ var b = $('ap-' + x.id); if(b) b.onclick = function(){ appliquer(x.cfg); }; }

function propose(){
  var c = genCouleurs();
  if(!c){
    $('props').innerHTML = '<div class="note">Choisis au moins la couleur principale de ta moto 👆</div>';
    return;
  }
  /* trois compositions, une par palier, la même logique de couleur pour les trois.
     On les range par prix : le client lit du moins cher au plus complet. */
  var choix = PALIERS.map(composer).filter(Boolean)
                     .sort(function(a, b){ return a.cfg.price - b.cfg.price; });

  /* On dit où atterrit chaque couleur ET quelle part de la selle elle occupe :
     c'est ce qui fait sentir au client qu'on a suivi SA moto. */
  var pc = function(n){ return String(n).replace('.', ',') + ' %'; };
  $('props').innerHTML = '<div class="mescouleurs" style="grid-column:1/-1">🎨 '
    + '<b>' + nomCoul(c[0]) + '</b> sur le dessus — ' + pc(SURF.dessus) + ' de la selle · '
    + '<b>' + nomCoul(c[1]) + '</b> sur les côtés — ' + pc(SURF.cotes) + ' · '
    + '<b>' + nomCoul(c[2]) + '</b> sur les bandes et l’insert — ' + pc(SURF.petites)
    + '</div>'
    + choix.map(function(x, i){ return carte(x, i === 1 ? ' hi' : ''); }).join('');
  choix.forEach(function(x){ lier(x); });
}

function appliquer(cfg){
  C.dessus.s   = cfg.dessus;
  C.coteHaut.s = cfg.coteHaut;
  C.coteBas.s  = cfg.coteBas;
  C.insert.s   = cfg.insert;
  C.bandes.mode = 'uni';
  C.bandes.s   = [cfg.b[0], cfg.b[1], cfg.b[2]];
  C.logo.s     = cfg.logo;
  C.touched.dessus = C.touched.cotes = C.touched.insert
                   = C.touched.bandes = C.touched.logo = true;
  $('gen').classList.remove('on');
  cur = STEPS.length - 1; render();
  window.scrollTo({ top:0, behavior:'smooth' });
}

/* le bouton flottant recouvrait des options : on l'escamote quand on descend */
(function(){
  var fab = $('genfab'); if(!fab) return;
  var dernier = 0;
  window.addEventListener('scroll', function(){
    var y = window.scrollY || 0;
    fab.classList.toggle('cache', y > dernier + 4 && y > 120);
    dernier = y;
  }, { passive:true });
})();

if($('genfab')){
  $('genfab').onclick   = function(){ $('gen').classList.add('on'); renderGen(); $('props').innerHTML = ''; };
  $('genclose').onclick = function(){ $('gen').classList.remove('on'); };
  $('genGo').onclick    = propose;
}

/* ---------- démarrage ---------- */
function demarrer(j){
  FIN = j;
  /* on cale l'état de départ sur des finitions qui existent vraiment */
  C.dessus.s   = valide('dessus', C.dessus.s);
  C.coteBas.s  = valide('cote-bas', C.coteBas.s);
  C.coteHaut.s = valide('cote-haut', C.coteHaut.s);
  C.insert.s   = valide('insert', C.insert.s);
  C.bandes.s   = C.bandes.s.map(function(s,i){ return valide('grip'+(i+1), s); });
  C.logo.s     = valide('logo', C.logo.s);
  /* une config sauvegardée avant le passage à la palette FUSION peut porter une
     couleur de surpiqûre qui n'existe plus (jaune fluo) : on la ramène au blanc */
  C.brodNum.c  = filBrodValide(C.brodNum.c);
  C.brodPse.c  = filBrodValide(C.brodPse.c);

  /* la rubrique de marque d'où arrive le client, pour ne lui montrer que ses motos */
  gamme = litGamme();
  var vis = modelesVisibles();
  /* une seule moto dans la rubrique (Rieju, Sherco, Fantic) : rien à choisir,
     on la pose d'office plutôt que de faire ouvrir un menu à une ligne */
  if(gamme && vis.length === 1 && !C.modele){ C.modele = vis[0]; touch('modele'); }

  render();
}

if(FIN_INTEGRE){ demarrer(FIN_INTEGRE); }
else {
  /* repli si le fichier n'a pas encore ete incruste (ne marche qu'en HTTP) */
  fetch('finitions.json').then(function(r){ return r.json(); }).then(demarrer)
    .catch(function(){
      $('pane').innerHTML = '<div class="note">Les finitions ne sont pas incrustées dans ce fichier. '
        + 'Lance <code>node 8-app-shopify/scripts/build-finitions-velto.js</code> puis recharge.</div>';
    });
}
})();
